// src/services/api.js
import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api',
});

// Request interceptor to add the auth token to every request
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Add tenant ID header (using system for super admin by default)
        config.headers['x-tenant-id'] = localStorage.getItem('tenantId') || 'system';

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Authentication disabled - no automatic redirect to login
        // if (error.response?.status === 401) {
        //     // Clear token and redirect to login if unauthorized
        //     localStorage.removeItem('token');
        //     window.location.href = '/login';
        // }
        return Promise.reject(error);
    }
);

export default api;